var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    {
      key: _vm.postData.id,
      ref: "page",
      staticClass: "release",
      class: _vm.postData.release_type,
    },
    [
      _vm.layout === "suave"
        ? [_c("k-browser-content")]
        : [
            _c(
              "d-main-image",
              _vm._b(
                { on: { load: _vm.pageLoaded } },
                "d-main-image",
                { img: _vm.img, show: _vm.show },
                false
              )
            ),
            _c("k-hero"),
            _c(
              "k-main",
              { attrs: { title: _vm.title } },
              [
                _c(
                  "media-info-icons",
                  _vm._b(
                    { attrs: { post: _vm.post || _vm.storedPost } },
                    "media-info-icons",
                    { postData: _vm.postData },
                    false
                  )
                ),
                _vm.wideMode
                  ? _c("section", {
                      staticClass: "description",
                      domProps: { innerHTML: _vm._s(_vm.content) },
                    })
                  : _vm._e(),
                _vm.series
                  ? _c("filmstrip", {
                      attrs: {
                        title: "in this series",
                        contents: _vm.series,
                        current: _vm.postData.id,
                      },
                    })
                  : _vm._e(),
                _c("comments"),
              ],
              1
            ),
          ],
      _c("div", { staticClass: "bottom-spacer" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }